import { supportContactLinks } from '../landingContact';

export default function MenuSupport() {
  const links = supportContactLinks();
  return <details className="rd-disclosure menu-support">
    <summary>Serve aiuto?</summary>
    <p>Indicaci il ristorante e il problema. Non inviare password o dati dei clienti.</p>
    <div className="menu-import-tabs">
      {links.email && <a className="button button-small button-ghost" href={links.email.href}>Scrivi un’email</a>}
      {links.whatsapp && <a className="button button-small button-ghost" href={links.whatsapp.href} target="_blank" rel="noopener noreferrer">Assistenza WhatsApp</a>}
    </div>
  </details>;
}
